<script>
  import { createEventDispatcher } from "svelte";
  import wrappedFetch from "../../wrappedfetch.js";
  let dispatch = createEventDispatcher();

  function isEmpty(v) {
    return !v || v.trim().length === 0;
  }
  
  let emailResponse = null;
  let sendingEmail = false;
  let emailTo = "";
  let emailSubject = "Test Email from eAdmissions";
  let emailBody = "This is testing Emails from eAdmissions";

  let smsResponse = null;
  let sendingSMS = false;
  let smsTo = "";
  let smsMessage = "Testing SMS";

  let pushResponse = null;
  let sendingpush = false;
  let pushUserId = "";
  let pushMessage = "Testing Push Notification Messages";

  let PCpushResponse = null;
  let PCsendingpush = false;
  let PCpushUserId = "";
  let PCpushMessage = "Testing ParentComms Push Notification Messages";

  const getPageDetails = async () => {
    const response = await wrappedFetch("debugger");
    const data = await response.json();
    emailTo = data.email;
    smsTo = data.contact;
    pushUserId = data.username;
    PCpushUserId = data.username
    return data;
  };

$: emailInvalid =
    isEmpty(emailTo) ||
    isEmpty(emailSubject) ||
    isEmpty(emailBody);

  async function sendEmail() {
  if (emailInvalid || sendingEmail) return;

  sendingEmail = true;
  emailResponse = null;

  try {
    const res = await fetch("/debugger/testemail", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        to: emailTo,
        subject: emailSubject,
        body: emailBody
      })
    });

    emailResponse = await res.json();
  } catch (err) {
    emailResponse = { success: false, message: err.message };
  } finally {
    sendingEmail = false;
  }
}


$: SMSInvalid =
    isEmpty(smsTo) ||
    isEmpty(smsMessage);

  async function sendSms() {
    if (SMSInvalid || sendingSMS) return;

  sendingSMS = true;
  smsResponse = null;

  try {
    const res = await fetch("/debugger/testsms", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        to: smsTo,
        message: smsMessage
      })
    });
    smsResponse = await res.json();
  } catch (err) {
    smsResponse = { success: false, message: err.message };
  } finally {
    sendingSMS = false;
  }
  }

$: pushInvalid =
    isEmpty(pushUserId) ||
    isEmpty(pushMessage);

  async function sendPush() {
  if (pushInvalid || sendingpush) return;

  sendingpush = true;
  pushResponse = null;

  try {
    const res = await fetch("/debugger/testpush", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        userId: pushUserId,
        message: pushMessage
      })
    });
    pushResponse = await res.json();
  } catch (err) {
    pushResponse = { success: false, message: err.message };
  } finally {
    sendingpush = false;
  }
  }


$: PCpushInvalid =
    isEmpty(PCpushUserId) ||
    isEmpty(PCpushMessage);

  async function sendPCPush() {
  if (PCpushInvalid || PCsendingpush) return;

  PCsendingpush = true;
  PCpushResponse = null;

  try {
    const res = await fetch("/debugger/testPCpush", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        userId: PCpushUserId,
        message: PCpushMessage
      })
    });
    PCpushResponse = await res.json();
  } catch (err) {
    PCpushResponse = { success: false, message: err.message };
  } finally {
    PCsendingpush = false;
  }
  }


</script>



<svelte:head>
  <title>Debugger Page | eAdmissions</title>
</svelte:head>


 <section class="">

    <div class="container">
      <div class="tile is-parent" style="padding: 0rem;">
        <article
          aria-label="Home Page Header"
          class="tile is-child notification"
          style="background-color: transparent;">
          <h1 class="title" style="color: #70457a; text-align:center;">
            Debugger Page
          </h1>
        </article>
      </div>

      {#await getPageDetails() then details}
        <pre>{JSON.stringify(details, null, 2)}</pre>
      {/await}

      <hr>

      <div class="box">
        <h2>📧 Test Email</h2>

        <input class="input" placeholder="To email" bind:value={emailTo} />
        <input class="input" placeholder="Subject" bind:value={emailSubject} />
        <textarea class="textarea" placeholder="Body" bind:value={emailBody}></textarea>

        {#if emailInvalid}
          <p class="has-text-danger">All fields are required</p>
        {/if}

        <button class="button is-primary" disabled={emailInvalid} on:click={sendEmail}>
          Send Email
        </button>
        {#if emailResponse}
  {#if emailResponse.success}
    <div class="notification is-success">
      ✅ Email sent successfully
    </div>
  {:else}
    <div class="notification is-danger">
      ❌ {emailResponse.message}
    </div>
  {/if}
{/if}
      </div>

      <div class="box">
        <h2>📱 Test SMS</h2>

        <input class="input" placeholder="Mobile number" bind:value={smsTo} />
        <textarea class="textarea" placeholder="Message" bind:value={smsMessage}></textarea>

        {#if SMSInvalid}
          <p class="has-text-danger">All fields are required</p>
        {/if}
        <button class="button is-warning" on:click={sendSms}>
          Send SMS
        </button>
        {#if smsResponse}
          {#if smsResponse.success}
            <div class="notification is-success">
              ✅ SMS sent successfully
            </div>
          {:else}
            <div class="notification is-danger">
              ❌ {smsResponse.message}
            </div>
          {/if}
        {/if}
      </div>

      <div class="box">
        <h2>🔔 Test WebPush Notification</h2>

        <input class="input" placeholder="Username" bind:value={pushUserId} />
        <textarea class="textarea" placeholder="Message" bind:value={pushMessage}></textarea>

        {#if pushInvalid}
          <p class="has-text-danger">All fields are required</p>
        {/if}
        <button class="button is-info" on:click={sendPush}>
          Send Push
        </button>
        {#if pushResponse}
          {#if pushResponse.success}
            <div class="notification is-success">
              ✅ Push Notification sent successfully
            </div>
          {:else}
            <div class="notification is-danger">
              ❌ {pushResponse.message}
            </div>
          {/if}
        {/if}
      </div>

      <div class="box">
        <h2>🔔 Test ParentComms Push Notification</h2>

        <input class="input" placeholder="PCUsername" bind:value={PCpushUserId} />
        <textarea class="textarea" placeholder="PCMessage" bind:value={PCpushMessage}></textarea>

        {#if PCpushInvalid}
          <p class="has-text-danger">All fields are required</p>
        {/if}
        <button class="button is-info" on:click={sendPCPush}>
          Send Push
        </button>
        {#if PCpushResponse}
          {#if PCpushResponse.success}
            <div class="notification is-success">
              ✅ Push Notification sent successfully
            </div>
          {:else}
            <div class="notification is-danger">
              ❌ {PCpushResponse.message}
            </div>
          {/if}
        {/if}
      </div>
  </div>
</section>
